var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagamentoNotaFiscal.documentoId)?_c('span',{staticClass:"text-success mr-2"},[_c('i',{staticClass:"fa fa-download fa-lg icon-button",attrs:{"title":"Download da Nota Fiscal"},on:{"click":function($event){$event.stopPropagation();return _vm.downloadNotaFiscal()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }